import { g as r } from "./global.js";
import { f as s } from "./function-apply.js";
import { i as t } from "./is-callable.js";
import { e as n } from "./engine-is-bun.js";
import { e as i } from "./engine-user-agent.js";
import { a } from "./array-slice.js";
import { v as e } from "./validate-arguments-length.js";
var o,
  m = r.Function,
  l = /MSIE .\./.test(i) || n && ((o = r.Bun.version.split(".")).length < 3 || 0 == o[0] && (o[1] < 3 || 3 == o[1] && 0 == o[2])),
  f = function f(r, n) {
    var i = n ? 2 : 1;
    return l ? function (o, l) {
      var f = e(arguments.length, 1) > i,
        u = t(o) ? o : m(o),
        p = f ? a(arguments, i) : [],
        g = f ? function () {
          s(u, this, p);
        } : u;
      return n ? r(g, l) : r(g);
    } : r;
  };
export { f as s };